import React, { useState } from 'react'
import { Drawer } from 'antd'
import { useHistory, useParams } from 'react-router-dom'

import { useToggle, usePet } from '../../modules'

import Receive from '../reusable/receive'
import { EntryFields } from '../reusable/inputs'
import CompleteNDiscard from '../reusable/completeNDiscard'

const Commentary = ({ onClose, dep }) => {
    const [entry, setEntry] = useState()

    const history = useHistory()
    const { id, entry: eid } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error }, getEntry] = usePet('singleEntry', { id: eid }, { notify: true, callback: ({ data }) => setEntry(data) })

    const close = () => {
        toggleVisible()
        onClose()
        setTimeout(() => history.goBack(), 300)
    }

    const reload = () => {
        setEntry()
        getEntry()
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <CompleteNDiscard
                        entry={ entry } 
                        close={ close } 
                        onClose={ onClose } />
                    <button onClick={ close } className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">Commentary</p>
            <p className="text-gray-500 text-xs italic">Write anything that would be necessary for future reference</p>
            <Receive
                progress
                loading={loading}
                error={error}>
                {
                    entry ?
                    <>
                        {
                            <EntryFields
                                reload={ reload }
                                entry={ entry }
                                fields={ entry?.item?.fields ?? [] } />
                        }
                    </>
                    : null
                }
            </Receive>
        </Drawer>
    )
}

export default Commentary